import type { ITracingProvider } from './types';
import { NoopProvider } from './noop_provider';

let _apm: ITracingProvider | null = null;

export async function initAPM(): Promise<ITracingProvider> {
  if (_apm) return _apm;
  const appId = (import.meta as any).env?.VITE_DD_APPLICATION_ID as string | undefined;
  const token = (import.meta as any).env?.VITE_DD_CLIENT_TOKEN as string | undefined;
  if (appId && token) {
    try {
      const { DatadogProvider } = await import('./datadog_provider');
      _apm = new DatadogProvider({ applicationId: appId, clientToken: token });
    } catch {
      _apm = new NoopProvider();
    }
  } else {
    _apm = new NoopProvider();
  }
  return _apm;
}

export function getAPM(): ITracingProvider {
  if (!_apm) _apm = new NoopProvider();
  return _apm;
}

export function isDatadogActive(): boolean {
  const env = (import.meta as any).env;
  return Boolean(env?.VITE_DD_APPLICATION_ID && env?.VITE_DD_CLIENT_TOKEN);
}
